import React, { useEffect, useState } from 'react';

const AuthDebug = () => {
  const [authInfo, setAuthInfo] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    setAuthInfo({
      hasToken: !!token,
      tokenLength: token ? token.length : 0,
      tokenPreview: token ? token.substring(0, 50) + '...' : 'No token',
      hasUser: !!user,
      userInfo: user ? JSON.parse(user) : null
    });
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <h4>Auth Debug</h4>
      <p>Has Token: {authInfo.hasToken ? 'Yes' : 'No'}</p>
      <p>Token Length: {authInfo.tokenLength}</p>
      <p>Token: {authInfo.tokenPreview}</p>
      <p>Has User: {authInfo.hasUser ? 'Yes' : 'No'}</p>
      {authInfo.userInfo && (
        <p>User Role: {authInfo.userInfo.role}</p>
      )}
    </div>
  );
};

export default AuthDebug;